import React from "react";

const ToU: React.FC = () => {
  return (
    <div className="mx-auto px-20 py-16 dark-blue bg-white">
      <h1 className="text-3xl font-bold mb-6">LEOTUS LIMITED</h1>
      <h2 className="text-xl font-semibold mb-4 mt-4">TERMS OF USE</h2>
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 mt-4">1. Introduction</h2>
        <p className="pl-4 Text dark-blue mb-2">
          These terms of use <b>(“Terms”)</b> constitute an electronic agreement
          between you (hereinafter <b>“Customer”, “You”, “you”, “Your”</b> or{" "}
          <b>“your”</b>) and Leotus Limited, a company incorporated in Gibraltar
          with registered number 122758 having its registered office situate at
          Finsbury House, 32 Line Wall Road, Gibraltar GX11 1AA (
          <b>“Leotus”, “we”, “our”</b> or <b>“us”</b>). Please note that, as
          used herein, “Leotus”, “we”, “our” and “us” refers to the company
          Leotus Limited, including but not limited to, its owners, directors,
          investors, officers, employees, agents or other related parties,
          unless otherwise provided herein.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          The Terms govern the relationship between Leotus, being the provider
          of the Services (as defined below), and you being a registered User
          (as defined below) of such Services.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          The Services are offered to you via the Leotus online platform (the
          <b>“Platform”</b>) which can be accessed via the Leotus website:
          www.leonext.exchange (the <b>“Website”</b>).
        </p>
        <p className="pl-4 Text dark-blue mb-2 font-bold">
          PLEASE READ THESE TERMS CAREFULLY. BY ACCESSING AND USING THE PLATFORM
          YOU WARRANT THAT YOU ACKNOWLEDGE THE RISK ASSOCIATED WITH THE USE OF
          THE PLATFORM AND THE SERVICES, AND THAT YOU ACCEPT AND AGREE TO BE
          BOUND BY THE TERMS, INCLUDING ALL OF THE WARRANTIES, INDEMNITIES, AND
          LIMITATIONS OF LIABILITY CONTAINED HEREIN.
        </p>

        <p className="pl-4 Text dark-blue mb-2">
          You have the right to refuse being bound by the Terms. Please note
          that we do not provide Users with the ability to negotiate the Terms.
          Therefore, if you wish to refuse and/or withdraw from the Terms, you
          should not use and/or access the Platform and the Services, or stop
          doing so.
        </p>

        <p className="pl-4 Text dark-blue mb-2">
          We reserve the right, at our sole discretion, to change or modify the
          Terms at any time. You will be notified of any changes in advance by
          email and by notification on the Website. Upon such notification, it
          is your responsibility to review the amended Terms. Your continued use
          of the Platform and the Services following the posting of a notice of
          changes to the Terms signifies that you accept and agree to the
          changes, and that all subsequent transactions by you will be subject
          to the amended Terms.
        </p>

        <p className="pl-4 Text dark-blue mb-2">
          You are solely responsible for understanding and complying with any
          and all laws, rules, and regulations that may be applicable to you in
          connection with your use of the Platform and any and all Services.
        </p>

        <p className="pl-4 Text dark-blue mb-2">
          The Terms incorporate the Privacy Policy (https://leonext.exchange/),
          AML & CFT Policy (https://leonext.exchange/), as well as any other
          policy that we may publish from time to time on the Platform (
          <b>“Policies”</b>), and reference to the Terms shall include the
          Policies. By accepting these Terms, you agree with and accept the
          Policies.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 mt-4">
          2. Definitions and Interpretation
        </h2>
        <ul className="mb-4 list-disc list-inside">
          2.1. In reading the Terms, please note the following:
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Clause, Schedule and paragraph headings shall not affect the
            interpretation of these Terms.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            A person includes a natural person, corporate or unincorporated body
            (whether or not having separate legal personality).
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Any applicable Schedules form part of these Terms and shall have
            effect as if set out in full in the body of these Terms. Any
            reference to these terms includes the Schedules.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            A reference to a company shall include any company, corporation or
            other body corporate, wherever and however incorporated or
            established.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Unless the context otherwise requires, words in the singular shall
            include the plural and, in the plural, shall include the singular
            and a reference to one gender shall include a reference to the other
            genders.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            These Terms and any other applicable Leotus Terms shall be binding
            on, and enure to the benefit of, the parties to the relevant Leotus
            Terms and their respective personal representatives, successors and
            permitted assigns, and references to any party shall include that
            party’s personal representatives, successors and permitted assigns.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            A reference to a statute or statutory provision is a reference to it
            as amended, extended or re-enacted from time to time.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            A reference to writing or written includes email and notifications
            made via the Platform.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Any obligation on a party not to do something includes an obligation
            not to allow that thing to be done.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Any reference to a legal term for any action, remedy, method of
            judicial proceeding, legal document, legal status, court, official
            or any legal concept or thing shall, in respect of any jurisdiction
            other than Gibraltar, be deemed to include a reference to that which
            most nearly approximates to the equivalent legal term in that
            jurisdiction.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            A reference to any term or to any other agreement or document
            referred to in the Terms is a reference to said agreement or
            document as varied or novated (in each case, other than in breach of
            the provisions of applicable Terms) from time to time.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            References to Clauses are to the Clauses of the respective terms and
            unless otherwise stated are to Clauses within the Section in which
            the reference appears. References to paragraphs are also to
            paragraphs of the relevant Section.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            References to Schedules are to the Schedules of the respective terms
            and references to paragraphs are to paragraphs of the relevant
            Schedule.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Any words following the terms including, include, in particular, for
            example or any similar expression shall be construed as illustrative
            and shall not limit the sense of the words, description, definition,
            phrase or term preceding those terms.
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            The definitions set out within this document apply to these Terms
            (including, for the avoidance of doubt, the Policies).
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Unless the context expressly providers otherwise, we use terms
            “Virtual Asset”, “Cryptocurrency” and “Crypto asset”
            interchangeably.
          </li>
        </ul>
        <p className="pl-4 Text dark-blue mb-2">
          “Account” The contractual arrangement wherein an individual has
          accepted the Terms, Fee Schedule and [insert policy], and received
          approval to use the Services, including the purchase and sale of
          Virtual Assets, and to perform associated Transactions.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Buyer(s)” Member(s) that submit an order to buy Virtual Assets
          through the Services.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Member(s)” Buyers and Sellers as well as any holder of an Account.
        </p>
        <ul className="mb-4 list-disc list-inside">
          “Instructions” Means:
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Instructions received or directed via the Website or as received
            directly from you in any medium other than the Website, where Leotus
            has expressly agreed in writing to accept such instructions from you
            other than via the Website;
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            Instructions mandated by law, regulatory authority or enforcement
            agencies.
          </li>
        </ul>
        <p className="pl-4 Text dark-blue mb-2">
          “Personal Data” Information that identifies an individual, such as
          name, address, email address, trading information and banking details.
          “Personal Data” does not include anonymised and/or aggregated data
          that does not identify a specific user.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Price” The “price per coin” for which Members are willing to buy or
          sell Virtual Assets. The Price may be expressed in any of the
          currencies supported on the Platform. See our Website for a full list
          of currencies.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Seller(s)” Member(s) that submit an order to sell Virtual Assets
          through the Platform.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Transaction” means any agreement between Leotus and a Buyer and/or
          Leotus and a Seller for the use of the Exchange Services.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          “Virtual Asset(s)” Digital representation of value that can be
          digitally traded, or transferred, and can be used for payment or
          investment purposes. Virtual Assets such as cryptocurrencies are a
          form of Virtual Asset designed to work as a medium of exchange that
          uses strong cryptography to secure financial transactions, control the
          creation of additional units and verify the transfer of assets.
          Virtual Assets use decentralised control as opposed to centralised
          digital currencies and central banking systems.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 mt-4">3. Services</h2>
        <ul className="mb-4 list-disc list-inside pl-4 dark-blue Text">
          3.1. We provide Users with the following exchange services via the
          Platform (hereinafter referred to as{" "}
          <b>“Exchange Services”, “Services”</b>
          or <b>“Service”</b>):
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            place Orders (as defined below) for the purchase of a Virtual Asset
            in exchange for other Virtual Assets;
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            place Orders (as defined below) for the purchase of Virtual Assets
            in exchange for fiat money; and
          </li>
          <li className="pl-4 Text dark-blue mb-1 mt-1">
            place Orders for purchase of fiat money in exchange for Virtual
            Assets.
          </li>
        </ul>
        <p className="pl-4 Text dark-blue mb-2">
          3.2. Our role is limited to providing you with the Services whereby we
          act solely as a service provider and in accordance with your
          Instructions for the purchase and/or sale of Virtual Assets.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          3.3. To enjoy access to the Services, you must first become a user (
          <b>“User”</b>) by registering with Leotus through the Platform in
          accordance with section 5 below.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          3.4. The Services are only accessible through an Account and are for
          the sole use and enjoyment of the User under which name the Account
          was opened (<b>“Account Holder”</b>).
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          3.5. Please note that from time to time, we may have to rely on
          certain third parties in order to provide the Services (
          <b>“Third Party Service Providers”</b> and each a{" "}
          <b>“Third Party Service Provider”</b>) and that, occasionally, you may
          be redirected to Third Party Service Providers’ platforms for
          submitting your payment and will be required to accept their specific
          terms and conditions. Your payment order will be handled and governed
          solely by the terms and conditions of such Third Party Service
          Providers. <b>YOU ARE SOLELY RESPONSIBLE</b> to ensure that the terms
          and conditions of any such Third Party Service Providers are suitable
          to you.
        </p>
      </section>
      <section className="mb-8">
        <h2 className="text-xl font-semibold mb-4 mt-4">4. Orders</h2>
        <ul className="pl-4 Text dark-blue">
          <b> 4.1. Placement of Orders</b>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            4.1.1. Orders pursuant to Exchange Services (<b>“Orders”</b>) are
            placed directly on the Platform through your Account. You understand
            that we execute all Orders in reliance on your promise that you
            intend to exchange a Virtual Asset for another Virtual Asset,
            Virtual Assets with fiat money, or vice versa as the case may be.
          </li>
          <ul className="pl-4 mb-2 Text dark-blue">
            4.1.2. When placing an Order, you will be prompted to provide us
            with the information we require to effect the Order (
            <b>“Instructions”</b>), including:
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              (i) the specific type of Virtual Asset or fiat money you intend to
              exchange (<b>“Consideration”</b>);
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              (ii) the amount of Consideration;
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              (iii) the specific type of Virtual Asset or fiat money which you
              desire to obtain in exchange for the Consideration; and
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              (iv) any other information which we would require to fulfil the
              Order, as this may be from time to time.
            </li>
          </ul>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            4.1.3. It is <b>YOUR SOLE RESPONSIBILITY</b> to ensure that all
            information provided to us under the Instructions is accurate and
            correct. Orders should only be submitted after careful consideration
            and once you understand and accept the consequences of their
            placement. You shall be responsible for monitoring all your Orders
            until we confirm execution, refusal or cancellation of the Order.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            4.1.4. We retain the right to immediately execute any Order and to
            act in accordance with any Instruction provided to us without
            further enquiry as to the genuineness, authority or the identity of
            the person to initiate such Instruction.{" "}
          </li>
        </ul>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            4.2. Indicative prices of Virtual Assets
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            We may present via the Platform indicative prices of Virtual Assets
            quoted in fiat money and/or in any other Virtual Asset (
            <b>“Indicative Prices”</b>). Indicative Prices presented to you
            through the Platform shall reflect approximations of the prices made
            available by us at the time at which they are displayed. Such prices
            do not necessarily reflect the prices for the Virtual Asset as
            quoted by other Third Party Service Providers dealing with the same
            Virtual Assets. Indicative Prices are only provided for
            informational purposes, and <b>DO NOT CONSTITUTE</b> binding offers.
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue font-bold mb-2">
            4.3. Limits on the amount of Consideration in an Order
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            We reserve the right to introduce minimum and maximum thresholds on
            the amounts of Consideration that Users may place in relation to an
            Order, to apply different thresholds to the different forms of
            Consideration, and to apply different thresholds to different Users.
            You may submit a request to amend any such thresholds by contacting
            us via email at :contact@leotus.tech and we, in our sole discretion,
            may decide whether to accommodate or refuse such a request.
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            4.4. Execution of Orders
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            Orders are made with reference to and executed in accordance with
            the prevailing market price(s) that are applicable to the
            Consideration and the specific Virtual Assets or fiat money that you
            wish to receive in exchange for the Consideration at the time of
            execution. The amount of Virtual Assets or fiat money received in
            exchange for the Consideration (<b>“Received Amount”</b>) will be
            automatically credited to the wallet address, the details of which
            you have provided to us in your Instructions.{" "}
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">4.5. Costs</p>
          <p className="pl-4 Text dark-blue mb-2">
            Any cost, including our Fees, any Third-Party Service Providers’
            fee, and/or any other commissions and or cost associated (
            <b>“Costs”</b>) with the Services (including network fees) shall be
            added to the Consideration. Please note that we may not be able to
            provide you with information on Costs applied by Third Party Service
            Providers.
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            4.6. Modification of Orders
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            Please note that due to the nature of Virtual Assets, and to the
            fact that some parts of the Exchange Services lie outside of our
            control, any attempt to modify an Order may not result in that Order
            being modified. As such, any request to modify a pending Order shall
            only amount to a request for us to attempt to do so. We shall
            confirm to you whether a request to modify an Order is successful.
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            4.7. Cancellation of Orders
          </p>
          <ul className="pl-4 Text dark-blue">
            We reserve the right to cancel an Order or part of an Order at all
            times upon the occurrence of, or due to:
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (i) the Order going above any threshold which we have set in
              accordance with section 4.3 above;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (ii) the Order being placed during a scheduled or unscheduled
              downtime of the Platform;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (iii) the Order being made in violation or where we have reason to
              suspect that the Order has been made in violation of the Terms, or
              any applicable rule, law, or regulation;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (iv) us having reasons to suspect that you may not be the person
              effecting the Order;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (v) the Order being non-marketable due to unfavourable market
              conditions;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (vi) any event outside of our control preventing us from providing
              access to the Platform or the Services, or to meet any other
              obligation we may be subject to under the Terms (
              <b>“Force Majeure Event”</b>);
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (vii) risk considerations;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (viii) us deeming that executing the Order would go against our
              legitimate interest, in accordance with our reasonable discretion.
            </li>
            Please note that we disclaim any liability associated with the
            cancellation of Orders, as more thoroughly described in section 14
            below.
          </ul>
        </div>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">5. Account</h2>
        <ul className="pl-4 Text dark-blue">
          <b>5.1. Registration Process</b>
          <li className="pl-4 Text dark-blue mb-2 mt-2">
            5.1.1. To open an Account on the Platform you must go through the
            registration process. The registration process effectively amounts
            to an application to Leotus for the opening of an Account on the
            Platform registered under your name and does not under any
            circumstance grant you any right over or in connection with the use
            of or access to the Platform and the Services.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.2. Only individuals who reached 18 years of age, or duly
            authorised representatives of legal entities are eligible to open an
            Account with Leotus.{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.3. Leotus reserves the right in its sole discretion to decline
            the opening of an Account, and to temporarily or permanently suspend
            access to any Account (or any part of it) where required or
            recommended to do so by applicable governmental, regulatory or law
            enforcement authorities or its own risk considerations.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.4. Being a Gibraltar company, Leotus is required to implement
            appropriate anti-money laundering and counter terrorist financing
            measures to ensure that the Platform and the Services are not used
            for or in connection with illicit activities. We are fully committed
            to complying with any such requirement and to ensure that our
            Platform and Services are only used for legitimate purposes in
            accordance with the Terms. In order to do so, we apply certain
            identification and verification measures when you register to open
            an account with us, and from time to time on an ongoing basis (
            <b>“Verification Process”</b>).
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.5. Please note that the opening of the Account is subject to the
            Verification Process and, particularly, to meeting our anti-money
            laundering requirements, which may be amended from time to time (
            <b>“AML Requirements”</b>).
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.6. As part of the Account registration process, you will be
            required to choose a username and password and, possibly, a
            multi-factor authentication system (collectively,{" "}
            <b>“Login Credentials”</b>). Please note that for security purposes
            we may require you to change the Login Credentials associated with
            your Account from time to time.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.1.7. You may only access your Account using your Login Credentials
            unless otherwise authorised by us.
          </li>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.2. Verification Process</b>
          <ul className="pl-4 Text dark-blue mt-2">
            5.2.1. As part of the Verification Process, you will have to provide
            Leotus with some documentation and information which is required for
            us to assess and verify your business activity and the identity of
            the principals behind your business to determine whether you meet
            our AML Requirements. Therefore, you shall provide us with the
            correct information that we may ask from you in order to carry out
            the Verification Process, which may include:
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              a. personal information such as, but not limited to, your name,
              address, date of birth, nationality;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              b. contact information including, your phone number, email
              address, and any other contact information which we may ask for
              from time to time;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              c. copies of identity documents, such as your passport or driving
              license, as well as proof of address, and any other such document
              as we may see fit to verify your identity and place of residence;
              and
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              d. copies of documents and information to verify your source of
              funds and/or wealth, including (i) details of other electronic
              wallets you hold with third party service providers; (ii)
              information on, or in connection with, deposits of Virtual Assets
              from wallets you hold with third-party service providers to the
              Wallet; and (ii) documentation and information on or in connection
              with deposits for fiat money from accounts you hold with other
              service providers.{" "}
            </li>
          </ul>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.2.2. Leotus reserves the right to, directly or indirectly (through
            Third Parties), make any inquiries we consider necessary to check
            the relevance and accuracy of the information you have provided as
            part of the Verification Process.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.2.3. We will inform you of whether you have met the AML
            Requirements and, as such, of whether you are eligible to open the
            Account and become a User, via your Primary Email Address (as
            defined below) or via the Leotus Platform interface, if appropriate,
            once all necessary and required checks are done.{" "}
          </li>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.3. Account Management</b>
          <li className="pl-4 Text dark-blue mb-2 mt-2">
            5.3.1. Subject to the Terms herein, you may only access your Account
            using the Login Credentials that are associated with it. You are
            solely responsible for managing and maintaining the security of your
            Login Credentials.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.2. If you are unable to access your Account, please contact us
            at: contact@leotus.tech providing a brief explanation on the reason
            as to why you are contacting us. However, please note while we may
            assist you in restoring access to your Account, we are under no
            obligation to do so.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.3. We reserve the right to make your continued access to and use
            of the Account, the Platform, and the Services subject to a new
            Verification Process, and/or to the provision of additional
            information which we may require in order to determine whether you
            meet our AML Requirements as these may be from time to time.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.4. You are responsible for ensuring that the information
            associated with your Account is correct at all times, to maintain
            the correctness and veracity of any such information, and to notify
            us of any material change to it within 5 calendar days of such
            change taking place by writing to us at the following email address:
            contact@leotus.tech.{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.5. You may find all information and details pertaining to your
            Account including to all of the activity taking place on your
            Account (“Account Information”) on the Platform. The Account
            Information will automatically include and display all activity as
            soon as reasonably practical right after the activity takes place on
            the Account.{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.6. Unless otherwise required by law, information which we make
            available to you through the Account Information (including
            confirmations and account statements) shall be deemed delivered to
            you within 1 calendar day of being available to you.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.7. We may at our sole discretion withdraw or amend any Account
            Information at any time. To the extent permitted by law, and subject
            to any agreement to the contrary, you agree that we are under no
            obligation to provide you with Account Information in paper form.{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.8. The Account Information (save if manifestly incorrect) will
            be conclusive evidence of the activity taking place on the Account
            and will be binding on you if not objected by you to in writing
            within 7 calendar day of being available on the Platform as part of
            the Account Information.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.3.9. To object the accuracy of the Account Information or of any
            part of it, please write to us at the following email address:
            contact@leotus.tech.{" "}
          </li>
          <ul className="pl-4 Text dark-blue">
            5.3.10. The Account Information is private to you, and is only made
            available:
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (i) to you, in your capacity as Account Holder;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              (ii) to Leotus, only to the extent necessary for us to provide the
              Services and in observance of applicable customer protections and
              privacy measures; and
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              (iii) to such other person to which Leotus must disclose the
              Account Information by virtue of applicable rules, laws, and
              regulations (if any).
            </li>
          </ul>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.4. Multiple Accounts</b>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.4.1. Leotus may, in its sole discretion, allow you to hold more
            than one Account and, always in its sole discretion, limit the
            number of Accounts that you may have under your name.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.4.2. To request an additional Account, please write to us at the
            following email address: contact@leotus.tech, providing the reason
            for such a request.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.4.3. For the avoidance of doubt, each account shall be subject to
            the Terms independently and to the same extent.
          </li>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.5. Account Security</b>
          <ul className="pl-4 Text dark-blue mt-1">
            It is your responsibility to secure and maintain access to your
            account and to implement the following measures (
            <b>“Account Security”</b>):
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              a. selecting a unique password that you do not use for other
              websites, by periodically updating your Login Credentials, and by
              keeping your Login Credentials and other forms of authentication
              confidential and separate from each other;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              b. keeping your Login Credentials strictly confidential;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              c. logging out of your Account whenever you are not using it;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              d. keeping any device, you use to gain access to the Platform safe
              and secure and locked with a secure password or other security
              mechanism and ensuring email account(s) you use to communicate
              with us are also secure and only accessed by you;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              e. changing your Account access information regularly;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              f. promptly notify us at: contact@leotus.tech, of any SMS, email,
              questionnaire, survey, or other request of information requesting
              you to provide your Login Credentials, and under no circumstance
              providing such information through any such request. For the
              avoidance of doubt, we will NEVER request your Login Credentials;
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              g. notifying us promptly at contact@leotus.tech if your Login
              Credentials have been lost or stolen, or if you have reason to
              believe that any person other than you has gained or may gain
              access to it;
            </li>
          </ul>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.6. Unauthorised Use</b>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.6.1. If any activity on your Account was not authorised by you (
            <b>“Unauthorised Use”</b>), or if you have any reason to suspect so,
            you must inform us as soon as possible by writing to us at the
            following email address contact@leotus.tech. For the avoidance of
            doubt, Unauthorised Use shall also cover instances where your
            Account was wrongly charged due to a mistake on our part.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.6.2. Failure to notify us immediately after you identified the
            Unauthorised Access may result in you losing your entitlement to
            have us investigate your matter and, subject to our reasonable
            discretion, correct it.
          </li>
        </ul>
        <ul className="pl-4 Text dark-blue">
          <b>5.7. Account Suspension and Termination</b>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.1. Users may terminate their Account at any time, by providing
            us with a one month written notice and following settlement of any
            pending activity on their Account. The notice shall be delivered to
            us at: contact@leotus.tech in the form of an email detailing the
            User’s intent to terminate the Account.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.2. The suspension or termination of an Account shall not affect
            the payment of Costs that may be due for past activity on the
            Account or for past activity that is associated with the Account.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.3. Upon termination of the Account, and unless the termination
            of the Account was due to any illicit activity, the User shall
            provide valid bank account details or Virtual Asset address to allow
            Leotus to transfer the remaining balance on the Account (if any) to
            any such bank account or Virtual Asset address. Leotus endeavours to
            transfer the Virtual Assets and fiat money as soon as reasonably
            practical following the User's request to terminate the Account.
            Please note that Third Party Service Providers or blockchain
            networks involved in the transfer of funds may apply certain charges
            to the transfer that may be beyond our control. We endeavour to use
            reasonable efforts to reduce any such charge to the extent possible.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.4. Leotus reserves the right to <b>SUSPEND</b> the provision of
            the Services to you and/or to <b>IMMEDIATELY TERMINATE</b> your
            Account if you refuse or fail to complete a Verification Process,
            including cases where you fail to provide the required information
            within the required time frame.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.5. Leotus reserves the right to <b>SUSPEND</b> the provision of
            the Services to you, to <b>IMMEDIATELY TERMINATE</b> your Account,
            and to take further actions <b>AGAINST YOU</b> in case we suspect
            that the Account is used in contravention with the Terms, and/or for
            or in connection with any illicit or fraudulent activity. This also
            includes, for example, provision of counterfeit documents and/or
            false personal information.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.6. Leotus reserves the right to <b>SUSPEND</b> the provision of
            the Services to you and/or to <b>IMMEDIATELY TERMINATE</b> your
            Account, and to take further actions <b>AGAINST YOU</b>, if we
            establish or have reasonable grounds to suspect that a request made
            by you in relation to your Account was made fraudulently.
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.7. You may not terminate your Account if you, or any activity on
            or connected to your Account is subject to an ongoing investigation.
            We reserve the right to <b>SUSPEND</b> and restrict access to your
            account and to <b>FREEZE</b> all Virtual Assets and fiat money on
            any Wallet that is associated with your Account until the
            investigation is concluded.{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.8. Please note that we reserve the right to store information
            pertaining to your Account following termination for at least five
            (5) years and that such information will be treated in accordance
            with the Terms (incorporating any of our Policies).
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            5.7.9. Please note that following termination, you shall remain
            liable for any activity on or in connection with your Account that
            occurred at the time when your Account was open.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-4 mt-4">6. Risk Warning</h2>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">6.1. General</p>
          <p className="pl-4 Text dark-blue mb-2">
            The risk of loss in trading or holding Virtual Assets can be
            substantial. You should therefore carefully consider whether trading
            or holding Virtual Assets is a suitable activity for you in light of
            your financial circumstances. You acknowledge that using Virtual
            Assets, their networks and protocols, involves serious risks. It is
            your duty to learn about all the risks involved with Virtual Assets,
            their protocols and networks. Even if we inform you of some of the
            risks involved with Virtual Assets, their protocols and networks,
            Leotus has no responsibility to alert you of all risks involved.
            Leotus has no control over and makes no representations regarding
            the value of Virtual Assets, or the security of their networks or
            protocols. You hereby further acknowledge that the Virtual Assets
            markets are determined by demand and supply only. The Virtual Assets
            market is a dynamic arena and their respective prices are often
            highly unpredictable and volatile. The prices of Virtual Assets are
            usually not transparent and are frequently highly speculative and
            susceptible to market manipulation. In the worst case scenario, the
            product could be rendered worthless. Moreover, there is always a
            risk that changes in the applicable legislative or regulatory regime
            may adversely affect the use, transfer, exchange, and value of
            Virtual Assets. Virtual Assets’ markets and exchanges are not
            currently regulated with the same control, and customers are not
            entitled to the same protections available in relation to financial
            instruments. You are solely responsible for determining whether any
            contemplated or actioned use of the Services is appropriate based on
            your personal goals, financial status and risk willingness. We do
            not guarantee the availability of any exchange rate. We do not
            guarantee that you will be able to buy and/or sell your Virtual
            Assets on the open market at any particular price or time.
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            For more information about risks related to Virtual Assets please
            refer to: [https://www.fatf-gafi.org/en/topics/virtual-assets].
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            6.2. No Advice or Guarantee{" "}
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            The content provided as part of the Services is for informational
            purposes only and should not be considered legal or financial
            advice. We may provide information on the price, range or volatility
            of Virtual Assets and events that have affected the price of Virtual
            Assets, but it should not be considered as investment or financial
            advice and should not be construed as such. Leotus is not acting,
            and cannot act, as an advisor including in relation to any
            financial, legal, investment, insurance or tax matters. Any
            information provided by Leotus is for general information only. You
            are solely responsible for determining whether any contemplated
            transaction is appropriate for you. You should consult with an
            attorney or other professional to determine what may be best for
            your individual needs. Leotus does not make any guarantee or other
            promise as to any results that may be obtained from using the
            Services. You should not make any investment decision without first
            consulting your financial advisor and conducting your own research
            and due diligence.{" "}
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            6.3. Internet and Computers Transmission Risks
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            There are risks associated with utilising an Internet-based system
            including, but not limited to, the failure of hardware, software,
            and Internet connections, the risk of malicious software
            introduction, and the risk that third parties may obtain
            unauthorized access to information stored on your behalf.
            Additionally, there is a risk of cyber-attacks on the security,
            integrity or operation of the Virtual Assets’ distributed ledger
            technology or any other underlying technology.{" "}
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            6.4. Distributed Ledger Technology Risks
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            Distributed ledger technology (also referred to throughout the Terms
            as <b>“blockchain”</b>) may be an independent public peer-to peer
            network and not controlled in any way or manner by us and, as such,
            we shall not be responsible for any failure, mistake, error or
            breach which shall occur on the blockchain or in any other networks
            on which the Virtual Assets are being issued or otherwise traded.
            You will be bound and subject to any change or amendments in the
            blockchain system and subject to any applicable law which may apply
            to the blockchain. We make no representation or warranty of any
            kind, express or implied, statutory or otherwise, regarding the
            blockchain functionality nor for any breach of security in the
            blockchain.{" "}
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">6.5. Forks</p>
          <p className="pl-4 Text dark-blue mb-2">
            The underlying protocols are subject to sudden changes in operating
            rules, and third parties may from time to time create a copy of a
            virtual assets network and implement changes in operating rules or
            other features (<b>“Forks”</b>) that may result in more than one
            version of a network (each, a <b>“Forked Network”</b>) and more than
            one version of a Virtual Asset (<b>“Forked Assets”</b>). You
            understand and acknowledge that Forked Networks and the available
            supply of any Forked Assets are wholly outside of the control of
            Leotus, and you further acknowledge that our ability to deliver
            Forked Assets resulting from a Forked Network may depend on
            third-parties that are outside of our control. You understand and
            acknowledge that Forks may materially affect the value, function,
            and/or even the name of the virtual assets you store in your
            wallet(s). In the event of a Fork, you understand and acknowledge
            that Leotus may temporarily suspend the Services (with or without
            advance notice to you) while we determine, at our sole discretion,
            which Forked Network(s) to support.
          </p>
        </div>
        <div>
          <p className="pl-4 Text dark-blue mb-2 font-bold">
            6.6. Past performance is not an indication for future performance
          </p>
          <p className="pl-4 Text dark-blue mb-2">
            Exchange rates are subject to fluctuations outside our control. Past
            movements or trends in the movement of Virtual Assets’ and fiat
            money exchange rates should not be taken as an indicator of future
            movements in such exchange rates.
          </p>
        </div>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">7. Fees</h2>
        <p className="pl-4 Text dark-blue mb-2">
          By using our Services you may incur certain fees and commissions (the
          <b>“Fees”</b>) as set out and available at: https://leonext.exchange/
          (the
          <b>“Fee & Limits Schedule”</b>), and as may be presented to you
          through the Platform when accessing and using the Services. We may
          revise and update the different Fees that are applicable to the
          Services from time to time and in our sole discretion. We will not
          charge you any fees other than the Fees set out in the Fee Schedule.{" "}
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">8. Taxes</h2>
        <p className="pl-4 Text dark-blue mb-2">
          Our Fees do not include any taxes, levies, duties or similar
          governmental assessments of any nature, including, for example,
          value-added, sales, use or withholding taxes, accessible by any
          jurisdiction whatsoever (collectively, <b>“Taxes”</b>). You are
          responsible for paying all Taxes associated with your Account
          hereunder, including all applicable country, federal, state and local
          taxes if applicable. If we have the legal obligation to pay or collect
          Taxes for which you are responsible, we will invoice you and you will
          pay that amount unless you provide us with a valid tax exemption
          certificate authorized by the appropriate taxing authority. You also
          agree that we may set-off such amounts.{" "}
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          9. Intellectual Property
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          9.1. All content on the Platform is the property of Leotus and, unless
          otherwise specified herein, is protected by copyright, patent,
          trademark and any other right that is available to us under applicable
          laws for the protection of intangible assets.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          9.2. Subject to section 9.3 below, the trademarks, trade names,
          service marks and logos of Leotus and others, software, applications,
          text, images, graphics, data, prices, trades, charts, graphs, video,
          audio materials, and any other form of intellectual property or
          intangible assets (<b>“Intellectual Property”</b>) used on the
          Platform belong to Leotus. You shall not copy, reproduce, modify,
          republish, upload, post, transmit, scrape, collect or distribute in
          any way, form or by any means, whether manual or automated, any part
          of our Intellectual Property. Any such unauthorized use may violate
          our rights under applicable laws and could result in criminal or civil
          penalties against you.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          9.3. Notwithstanding any of the above, any Intellectual Property on
          the Platform belonging to a third party shall remain property of that
          third party.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          10. Treatment of your personal information
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          Please rest assured that any Personal Information (as defined under
          Regulation (EU) 2016/679 (<b>“GDPR”</b>)) that we may need to process
          to provide you with the Platform and the Services or in connection
          with the Platform and the Services, will be processed in accordance
          with our PRIVACY POLICY, as amended from time to time, available at
          https://leonext.exchange/, and in observance with any rule, law, and
          regulation as may be applicable to us from time to time when carrying
          out such processing.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">11. Disclaimer</h2>
        <p className="pl-4 Text dark-blue mb-2">
          11.1. The Platform and the Services are provided “as is”, without
          guarantees of any kind, either expressed or implied. While we strive
          to maintain access to the Platform, all online services suffer from
          occasional disruptions and outages, and we are not liable for any
          disruption or loss you may suffer as a result. Therefore, please note
          that we do not provide any guarantees that access to the Platform and
          the Services will not be interrupted or that there will be no delays,
          failures, errors, omissions or loss of transmitted information.
          However, we use reasonable endeavours to ensure that you can access
          the Platform and the Services in accordance with these Terms. Please
          also note that we may suspend access to the Platform for maintenance
          and we will make reasonable efforts to give you sufficient notice of
          such disruption. However, you acknowledge and accept that this may not
          be possible in an emergency.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.2. For the avoidance of doubt, the Platform and any other online or
          offline material offered or produced by us, does not constitute an
          offer or solicitation to anyone in any jurisdiction in which such
          offer or solicitation is not authorised, to any person for whom access
          and use of the Services and the Platform is unlawful, or to whom it is
          otherwise unlawful to make such an offer or solicitation.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.3. Leotus DOES NOT offer or intend to offer, nor purport to offer
          to you or any of the Users any investment or financial advice, nor any
          other form of advice in relation to the Services.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.4. For the avoidance of doubt, the ability to access the Platform
          and the Services DOES NOT mean that the Services are legally viable
          under rules, laws, and regulations that are applicable to you. It is
          your sole responsibility to verify that you have the legal capacity to
          access and to use the Platform and the Services. Failing to do so
          constitutes a breach of the duty you are subject to under the
          warranties listed in section 13 below.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.5. We do not provide any guarantee for any Third Party Service
          Provider. You acknowledge and agree that you are solely responsible
          for your relationship with any Third Party Service Provider. We shall
          not be liable for anything arising out or as a result of your
          acceptance to be bound to any Third Party Service Provider terms and
          conditions
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.6. You understand and acknowledge that we do not guarantee that
          Orders placed on the Platform will be executed, and that we have the
          right to cancel any Order in accordance with section 4.7 above,
          without any liability whatsoever to the fullest extent permitted by
          law, including but not limited to liability for damages, loss of
          profit, loss of revenue, loss of business, loss of opportunity, loss
          of data, indirect or consequential loss arising from our decision.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.7. We shall not be liable for any inability to modify an
          Instruction. You understand and agree that, if an Instruction cannot
          be cancelled or modified, you are bound by any execution of the
          original Instruction.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.8. We shall not be responsible or liable for any loss, damage, or
          other form of sufferance resulting from any of the risk detailed in
          section 6 above.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          11.9. We shall not be liable for, and we shall enjoy sole discretion
          when determining whether or not to support a forked network. You agree
          that we may determine the approach to such forked assets, which may
          include abandoning or otherwise electing not to support such forked
          assets as part of the services. You understand and hereby acknowledge
          that Leotus is unlikely to support most forked networks and that most
          forked assets will likely not be made available to you, and that you
          shall have no right, claim, or other privilege to a forked asset that
          is not supported by Leotus.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">12. Warranties</h2>
        <ul className="pl-4 Text dark-blue">
          12.1. You hereby warrant and guarantee that in accessing and/or using
          the Platform and the Services:
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.1. you are complying with the Terms and that you will comply
            with the Terms at all times;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.2. you are complying with all rules, laws, and regulations
            applicable to you (as these may be from time to time) by virtue of
            your place of residence, or by virtue of any circumstance that is
            otherwise specific to you;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.3. if you are a natural person, that you are at least 18 years
            old;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.4. you are of sound mind, and legally capable of taking
            responsibility for your own actions;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.5. you will comply at all times with the Terms and will not
            take any action which is in breach of the Terms, or any applicable
            law, rule, and regulation, or cause, induce and/or assist any other
            person to carry out any such action;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.6. you will not behave immorally, and in a manner that may put
            our reputation at risk;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.7. any and all information that is associated with your Account
            is correct and that you shall maintain it correct and up to date;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.8. any and all Virtual Assets and fiat money used in connection
            with your Account and with the Platform derives exclusively from
            legitimate activities;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.9. you will ensure that any and all information provided in
            each Order is accurate, correct and a reflection of your intention;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.10. you shall maintain the Account Security at all time;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.11. you are entitled to and have all necessary rights to any
            Intellectual Property submitted by you or otherwise uploaded to the
            Platform;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.1.12. before using any of the Services, you shall make your own
            independent assessment as to whether the Services are appropriate
            for you, based upon your understanding of the risks detailed in
            section 6 above, upon your own judgment, and upon such independent
            advice as you may seek from any third party advisers to the extent
            you deem it necessary.
          </li>
          <ul className="pl-4 Text dark-blue">
            12.1.13. you are not engaged, either directly or indirectly, in any
            of the following prohibited activities:
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              a. registration of more than one Account, unless explicitly
              allowed by us in writing, following a request pursuant to section
              5.4 above;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              b. registration of an Account if your previous account was
              suspended indefinitely or terminated by us, unless explicitly
              allowed by us in writing;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              c. participation in any attempts to manipulate or in any way
              subvert the rights or obligations of Leotus, any User, or any
              third party;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              d. initiation or in any way participation in any attempts to gain
              unauthorized access to any part of the Website or any part of the
              Platform, or in any way impair the security, functionality or
              performance of the Platform, or the Services;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              e. infringement of Leotus’ or any third party’s Intellectual
              Property, or rights of publicity or privacy;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              f. act in a manner that is defamatory, libellous, threatening or
              harassing with respect to your interaction with us;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              g. harass Leotus’ employees, agents, or other Leotus Account
              holders;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              h. provide us with false, inaccurate or misleading information;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              i. refuse to cooperate in an investigation or provide confirmation
              of your identity or any information you provide to Leotus; and
            </li>
            <li className="pl-4 Text dark-blue mb-2 mt-1">
              j. you are entitled to and have all necessary rights to any
              Intellectual Property submitted by you or otherwise uploaded to
              the Platform.
            </li>
          </ul>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            12.2. Leotus hereby warrants to you that we shall provide the
            Services with reasonable care and skill in accordance with the
            Terms, and that we endeavour that the Platform provides for a safe
            environment for you to enjoy the Services.
          </li>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">13. Indemnities</h2>
        <ul className="pl-4 Text dark-blue">
          13.1. To the widest extent permitted by law, you hereby agree to
          protect, defend, indemnify and hold us harmless from and against any
          and all claims, demands, costs, expenses, losses, liabilities and
          damages of every kind and nature (including, without limitation,
          reasonable attorneys' fees) imposed upon or incurred by us directly or
          indirectly arising from:
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            13.1.1. your use of and access to the Platform and the Services;{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            13.1.2. any breach of the Terms, including a breach of any of the
            warranties listed in section 12 above;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            13.1.3. any breach of any rule, law or regulation on your part, and
            any immoral behaviour you undertake, either directly or indirectly;
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            13.1.4. your acceptance, breach, or any other activity connected to
            Third Party Services Providers’ terms and conditions;{" "}
          </li>
          <li className="pl-4 Text dark-blue mb-2 mt-1">
            13.1.5. your violation of any third party right, including without
            limitation any Intellectual Property or other proprietary right;
          </li>
          <ul className="pl-4 Text dark-blue">
            13.1.6. your inability to access or use the Services resulting from:
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              a. your non-compliance with any Verification Process or other
              compliance procedures which we may, in our reasonable discretion,
              require you to go through from time to time;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              b. any applicable rule, law, or regulation;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              c. any Unauthorised Use, arising out of or in connection with your
              breach of the Terms, including any failure to safeguard the
              security of your Account;
            </li>
            <li className="pl-4 Text dark-blue mb-1 mt-1">
              d. any damage or losses resulting from theft or any loss of
              control of your Account, other than theft and loss of control
              resulting from our fault or negligence.
            </li>
            The indemnification obligations under this section shall survive any
            termination or expiration of the Terms or the User's use of the
            Platform or the Services.
          </ul>
        </ul>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          14. Limitations of Liability
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          TO THE WIDEST EXTENT PERMITTED BY LAW, IN NO EVENT SHALL LEOTUS, ITS
          OFFICERS, DIRECTORS, EMPLOYEES, AGENTS, AND ANY THIRD PARTY SERVICE
          PROVIDERS BE LIABLE TO THE USERS OR ANY OTHER PERSON OR ENTITY FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, PUNITIVE OR CONSEQUENTIAL
          DAMAGES OR LOSSES WHATSOEVER, CAUSED BY ANY OF THE FOLLOWING,
          INCLUDING BUT NOT LIMITED TO (I) ANY ERRORS, MISTAKES OR OMISSIONS BY
          THE USERS WHEN USING THE PLATFORM OR THE SERVICES WHICH CAUSE OR
          RESULT IN THE LOSS OF ANY AND ALL OF THEIR VIRTUAL ASSETS AND/OR FIAT
          MONEY, (II) ACCURACY, COMPLETENESS OR CONTENT OF AND ON THE PLATFORM,
          (III) ACCURACY, COMPLETENESS OR CONTENT OF ANY SITES LINKED (THROUGH
          HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO OUR PLATFORM, (IV) THE
          PLATFORM OR ANY SITES LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING
          OR OTHERWISE) TO THE PLATFORM, (V) PERSONAL INJURY OR PROPERTY DAMAGE
          OF ANY NATURE WHATSOEVER, (VI) THIRD-PARTY CONDUCT OF ANY NATURE
          WHATSOEVER, (VII) ANY UNAUTHORISED ACCESS TO OR USE OF OUR SERVERS
          AND/OR ANY AND ALL CONTENT, PERSONAL INFORMATION, FINANCIAL
          INFORMATION OR OTHER INFORMATION AND DATA STORED THEREIN, (VIII) ANY
          INTERRUPTION OR CESSATION OF THE SERVICES, THE PLATFORM OR ANY SITES
          LINKED (THROUGH HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO THE
          PLATFORM, (IX) ANY VIRUSES, WORMS, BUGS, TROJAN HORSES OR THE LIKE,
          WHICH MAY BE TRANSMITTED TO OR FROM THE PLATFORM OR ANY SITES LINKED
          (THROUGH HYPERLINKS, BANNER ADVERTISING OR OTHERWISE) TO THE PLATFORM,
          (X) ANY USER CONTENT OR CONTENT THAT IS DEFAMATORY, HARASSING,
          ABUSIVE, HARMFUL TO MINORS OR ANY PROTECTED CLASS, PORNOGRAPHIC,
          “X-RATED”, OBSCENE OR OTHERWISE OBJECTIONABLE AND/OR (XI) ANY LOSS OR
          DAMAGE OF ANY KIND INCURRED AS A RESULT OF A USER’S USE OF THE
          PLATFORM OR THE SERVICES, WHETHER BASED ON WARRANTY, CONTRACT, TORT OR
          ANY OTHER LEGAL OR EQUITABLE THEORY AND WHETHER OR NOT LEOTUS IS
          ADVISED OF THE POSSIBILITY OF SUCH DAMAGES. IN ADDITION, YOU
          SPECIFICALLY ACKNOWLEDGE AND AGREE THAT ANY CAUSE OF ACTION ARISING
          OUT OF OR RELATED TO THE PLATFORM OR THE SERVICES MUST BE COMMENCED
          WITHIN ONE (1) YEAR AFTER THE CAUSE OF ACTION ACCRUES, OTHERWISE SUCH
          CAUSE OF ACTION SHALL BE PERMANENTLY BARRED. IN ADDITION, THE USER
          SPECIFICALLY ACKNOWLEDGES AND AGREES THAT IN NO EVENT SHALL LEOTUS’
          TOTAL AGGREGATE LIABILITY EXCEED THE TOTAL AMOUNT PAID BY THE USER FOR
          THE PARTICULAR SERVICES THAT ARE THE SUBJECT OF THE CAUSE OF ACTION.
          THE FOREGOING LIMITATION OF LIABILITY SHALL APPLY TO THE FULLEST
          EXTENT PERMITTED BY LAW AND SHALL SURVIVE ANY TERMINATION OR
          EXPIRATION OF THIS AGREEMENT OR THE USER'S USE OF THE SITE, THE
          PLATFORM OR THE SERVICES.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">15. Miscellaneous</h2>
        <p className="pl-4 Text dark-blue mb-2">
          15.1. You agree and consent for us to communicate with you through the
          Platform and through the primary email address that is associated with
          your Account (<b>“Primary Email Address”</b>).
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.2. It is your responsibility to ensure that you log onto and
          regularly review the information that we make available to you through
          the Platform and the Primary Email Address. You shall also review and
          respond to any notice which we may send you regarding your Account
          Information, and to promptly reply to any of our questions. Failure to
          contact us in a timely manner in accordance with the Terms may result
          in loss of funds and/or important rights.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.3. You and Leotus agree that any party hereto may bring claims
          against the others only on an individual basis and not as a plaintiff
          or class member in any purported class or representative action or
          proceeding. No adjudicator may consolidate or join more than one
          person’s or party’s claims and may not otherwise preside over any form
          of a consolidated, representative, or class proceeding. Any relief
          awarded to any User cannot and may not affect any other User.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.4. These Terms do not intend to confer any benefit on any third
          party, and no third party shall have any rights to enforce any of
          these terms against us.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.5. You may not transfer, assign, or sell any rights or obligations
          you have under the Terms or otherwise grant any third party a legal or
          equitable interest over your Account without our prior written
          consent. Leotus reserves the right to transfer or assign the Terms or
          any right or obligation under the same to any party and at any time.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.6. If we fail to enforce any of our rights under any these Terms,
          or applicable laws, it shall not be deemed to constitute a waiver of
          such right.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.7. We may comply with any subpoena, levy, or other legal process
          brought against you if we believe it to be valid. We may notify you of
          such a process electronically, by phone, or in writing.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.8. We reserve the right, but shall have no responsibility, to edit,
          modify, refuse to post or remove any content, in whole or in part,
          from the Platform if we deem that such content is objectionable,
          erroneous, illegal, fraudulent or otherwise in violation of these
          Terms.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.9. Unless stated otherwise in these Terms, if any provision of the
          Terms is held to be invalid or unenforceable, such provision shall be
          struck and the remaining provisions shall be enforced to the extent
          possible.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.10. We reserve the right to amend, revise, modify, and/or change
          the Terms and/or the Services at any time. All changes shall take
          effect immediately and such updated version of the Terms shall be
          published through the Platform. You are solely responsible for
          periodically reviewing the Terms. If you do not agree with any such
          modification, your sole and exclusive remedy is to stop using the
          Services and submit a request to terminate your Account. You agree
          that we shall not be liable to you or any third party for any
          modification or termination of the Services and/or these Terms, or
          suspension or termination of your access to the Services, except to
          the extent otherwise expressly set forth herein.{" "}
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.11. We may, in our sole discretion and without liability to you,
          with or without prior notice and at any time, modify or discontinue,
          temporarily or permanently, all or any portion of our Services.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.12. The Terms, including the Policies and any other document or
          information incorporated by reference constitutes the entire agreement
          between you and Leotus, and govern your access to the Platform and use
          of the Services, superseding any prior agreements between you and
          Leotus with respect to the Platform and the Services.{" "}
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.13. If any provision or section of the Terms is found by a court of
          the competent jurisdiction or arbitrator to be invalid or
          unenforceable, the parties agree that the court or arbitrator should
          endeavour to give effect to the parties’ intentions as reflected in
          the provision, and that the other provisions of these Terms shall
          remain in full force and effect. If the court or arbitrator cannot do
          so, then the parties agree that the court or arbitrator should strike
          the invalid or unenforceable provisions, and that the remaining
          provisions be given their full force and effect.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          15.14. If we are unable to perform the Services outlined in the Terms
          due to factors beyond our control including but not limited to an
          event of Force Majeure, change of law or change in sanctions, we shall
          not be liable for the Services provided under this agreement during
          the time period coincident with the event.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          16. Prohibited Activities
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          16.1. You agree not to use the Services to perform criminal activity
          of any sort, including but not limited to, money laundering, illegal
          gambling operations, terrorist financing, malicious hacking or any
          criminal or illegal activity.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          16.2. You will refrain from using your Account, the Website and
          Services for any other use than your personal use, unless you are a
          legal entity that has opened a corporate account with us.
        </p>
      </section>
      <section>
        <h2 className="text-lg font-semibold mb-4">17. Limited Right of Use</h2>
        <p className="pl-4 Text dark-blue mb-2">
          17.1. Unless otherwise specified, all materials on the Website and the
          Platform, including, but not limited, to text, graphics, logos, icons
          and images (“Materials”), are the property of Leotus and are protected
          by copyright, trademark and other applicable laws. You may view, print
          and/or download a copy of the Materials from this Website and the
          Platform on any single computer solely for your personal,
          informational and/or non-commercial use, provided you comply with all
          copyright and other proprietary notices.
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          17.2. The trademarks, service marks and logos of Leotus and others
          used on the Website and the Platform (“Trademarks”) are the property
          of Leotus and their respective owners. The software, text, images,
          graphics, data, prices, trades, charts, graphs, video and audio used
          on the Website and the Platform belong to Leotus. The Trademarks and
          Material should not be copied, reproduced, modified, republished,
          uploaded, posted, transmitted, scraped, collected or distributed in
          any form or by any means, whether manual or automated. The use of any
          such Materials on any other website or networked computer environment
          for any other purpose is strictly prohibited; any such unauthorised
          use may violate copyright, trademark and other applicable laws and
          could result in criminal or civil penalties.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          18. User Support and Complaints
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          18.1. We take complaints seriously. Should you wish to make a formal
          complaint about us, about the Platform or about the Services we
          provide, please refer to our Complaints Policy which we have made
          available at: contact@leotus.tech.
        </p>
      </section>
      <section>
        <h2 className="text-xl font-semibold mb-4 mt-4">
          19. Governing Law and Jurisdiction
        </h2>
        <p className="pl-4 Text dark-blue mb-2">
          19.1. The Terms and any dispute or claim arising out of or in
          connection with the Terms, the Platform and/or the Services shall be
          governed by and construed in accordance with the laws of Gibraltar,
          unless otherwise expressly provided herein.{" "}
        </p>
        <p className="pl-4 Text dark-blue mb-2">
          19.2. You irrevocably agree that the courts of Gibraltar shall have
          exclusive jurisdiction to settle any dispute or claim arising out of
          or in connection with the Terms, the Platform and/or the Services.
        </p>
      </section>
    </div>
  );
};

export default ToU;
